import { render, staticRenderFns } from "./capital-market-publications.vue?vue&type=template&id=b16d092a&scoped=true&lang=pug&"
import script from "./capital-market-publications.vue?vue&type=script&lang=js&"
export * from "./capital-market-publications.vue?vue&type=script&lang=js&"
import style0 from "./capital-market-publications.vue?vue&type=style&index=0&id=b16d092a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16d092a",
  null
  
)

export default component.exports